import { Home, Search, TrackChanges } from "@mui/icons-material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { BeatLoader } from "react-spinners";
import Swal from "sweetalert2";
import * as Yup from "yup";
import IconBreadcrumbs from "../../components/custom/IconBreadcrumbs";
import {
  useLazyOptimizeClearQuery,
  useUpdatePaymentEchallonMutation,
} from "../../redux/api/dashboardApiSlice";
import { useEkpayPaymentVerifyMutation } from "../../redux/api/paymentApiSlice";
import { useVerifyEchalanMutation } from "../../redux/api/submittedCopyrightAgreementApiSlice";
import { globalDateFormat } from "../../utils/dateFormat";
import BanglaCalender from "../frontend/userPanel/form_two/BanglaCalender";

const Observation = () => {
  const [transId, setTransId] = useState("");
  const [paymentV, { isLoading: isLoadingV, isFetching: isFetchingV, data }] =
    useEkpayPaymentVerifyMutation();
  const [echalanVerify, { isLoading: isLoadingE, data: dataE, reset }] =
    useVerifyEchalanMutation();
  const [optimizeClear, { isLoading, isFetching }] =
    useLazyOptimizeClearQuery();
  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    { icon: TrackChanges, title: "পর্যবেক্ষণ", active: true },
  ];

  // E-CHALLAN UPDATED
  const [updateEchallan, { isLoading: isLoadingUp, isFetching: isFetchingUp }] =
    useUpdatePaymentEchallonMutation();

  const handleOptimizeClear = async () => {
    try {
      await optimizeClear().unwrap();
      toast.success("Optimize clear successful");
    } catch (error) {
      console.error(error);
    }
  };

  const handlePayemntVerify = async (e) => {
    e.preventDefault();
    try {
      await paymentV({ transactionNo: transId }).unwrap();
      reset();
      toast.success("Payment verification successful");
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      challanid: data?.data?.challanId || "",
      treasuryDate: globalDateFormat(data?.data?.transactionDate) || "",
    },
    validationSchema: Yup.object({
      challanid: Yup.string().required("চালান নাম্বার প্রযোজ্য"),
      treasuryDate: Yup.string().required("তারিখ প্রযোজ্য"),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      echalanVerify(values);
    },
  });
  const transactionNo = transId || data?.data?.transactionNo;

  const updateEchallanStatus = async () => {
    const result = await Swal.fire({
      text: "আপনি কি নিশ্চিত?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "না",
      confirmButtonText: "হ্যাঁ",
    });

    if (result.isConfirmed) {
      try {
        // Assuming updateEchallan is an async function that returns a promise
        await updateEchallan({
          transactionNo,
        }).unwrap();

        toast.success("ই-চালান আপডেট সফল হয়েছে");
      } catch (error) {
        console.error("Error updating e-challan:", error);
        toast.error("ই-চালান আপডেট করতে সমস্যা হয়েছে");
      }
    } else {
      console.log("User cancelled the action");
    }
  };

  return (
    <>
      <div className="py-3">
        <IconBreadcrumbs breadcrumbs={breadcrumbsData} />
      </div>
      <div className="slideUp dashboard-layout p-3">
        <div className="d-flex justify-content-between align-items-center bg-slate p-2 mb-3">
          <h6 className="fw-semibold fs-6 m-0">পর্যবেক্ষণ</h6>
          <Button
            size="sm"
            onClick={handleOptimizeClear}
            disabled={isLoading || isFetching}
          >
            {isLoading || isFetching
              ? "অপটিমাইজ ক্লিয়ার হচ্ছে..."
              : "অপটিমাইজ ক্লিয়ার"}
          </Button>
        </div>

        <div className="row">
          {/* Search Section */}
          <div className="col-md-6 h-100">
            <div className="bg-slate p-2">
              <form onSubmit={handlePayemntVerify}>
                <div className="row">
                  <div className="col-md-12 bg-3">
                    {" "}
                    <div className="m-1 fs-6 fw-semibold rounded">
                      পেমেন্ট যাচাই
                    </div>
                  </div>

                  <div className="col-md-8 col-7">
                    <Form.Control
                      name="challanid"
                      placeholder="ট্রানজেকশন নাম্বার"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={transId}
                      onChange={(e) => setTransId(e.target.value)}
                      required
                      type="search"
                    />
                  </div>
                  <div className="col-md-4  col-5 d-flex justify-content-end">
                    <Button
                      disabled={isLoadingV}
                      className="px-4"
                      variant="success"
                      size="sm"
                      type="submit"
                    >
                      {isLoadingV ? (
                        <BeatLoader color="#fff" />
                      ) : (
                        <>
                          <Search /> যাচাই করুন
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </form>

              {data && (
                <Card className="shadow-sm mt-4">
                  <Card.Body>
                    <Row>
                      <Col sm={6}>
                        <div className="mb-2">
                          <strong>আবেদন: </strong>
                          {data?.data?.application}
                        </div>
                        <div className="mb-2">
                          <strong>আবেদন নাম্বার: </strong>
                          {data?.data?.trackReg}
                        </div>

                        <div className="mb-2">
                          <strong>আবেদনকারী: </strong>
                          {data?.data?.name}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="mb-2">
                          <strong>পেমেন্ট: </strong>
                          {data?.data?.paymentMethod}
                        </div>
                        <div className="mb-2">
                          <strong>আইপিএন নাম্বার: </strong>
                          {data?.data?.ipn_txid}
                        </div>
                        <div className="mb-2">
                          <strong>টাকার পরিমাণ: </strong>
                          {data?.data?.amount}
                        </div>
                      </Col>
                      <div className="mb-2">
                        <strong>পেমেন্ট স্ট্যাটাস: </strong>
                        {data?.data?.message}
                      </div>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </div>
          </div>

          {/* Card Section to display payment details */}
          <div className="col-md-6">
            <div className="bg-slate p-2 h-100">
              <div className="row">
                <div className="col-md-12 bg-3">
                  {" "}
                  <div className="m-1 fs-6 fw-semibold rounded">
                    ই-চালান যাচাই
                  </div>
                </div>
              </div>
              {data?.data?.challanId && data?.data?.transactionDate && (
                <div className="row">
                  <div className="col-md-4">
                    <Form.Control
                      name="challanid"
                      placeholder="চালান নাম্বার"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={formik.values.challanid}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="col-md-4 ">
                    <BanglaCalender
                      onChange={(e) => {
                        formik.setFieldValue("treasuryDate", e);
                      }}
                      value={formik.values.treasuryDate}
                      placeholder={"তারিখ"}
                    />
                  </div>
                  <div className="col-md-4  d-flex justify-content-end">
                    <div className="">
                      <Button
                        onClick={formik.handleSubmit}
                        disabled={isLoadingE}
                        className="px-4"
                        variant="success"
                        size={"sm"}
                      >
                        {isLoadingE ? (
                          <BeatLoader color="#fff" />
                        ) : (
                          <>
                            <Search /> যাচাই করুন
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {dataE?.data && (
                <Card className="shadow-sm mt-4">
                  <Card.Body>
                    <Row>
                      <Col sm={6}>
                        <div className="mb-2">
                          <strong>পেমেন্ট নাম্বার: </strong>
                          {dataE?.data?.paymentId}
                        </div>
                        <div className="mb-2">
                          <strong>ই-চালান নাম্বার: </strong>
                          {dataE?.data?.echallanId}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="mb-2">
                          <strong>ই-চালান স্ট্যাটাস: </strong>
                          {dataE?.data?.eChallanStatus}
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </div>
          </div>

          <div className="col-md-6 mt-4">
            <div className="bg-slate p-2 h-100">
              <div className="row">
                <div className="col-md-12 bg-3">
                  {" "}
                  <div className="m-1 fs-6 fw-semibold rounded">
                    পেমেন্ট / ই-চালান আপডেট
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8 col-7">
                  <Form.Control
                    name="challanid"
                    placeholder="ট্রানজেকশন নাম্বার"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    value={transId}
                    onChange={(e) => setTransId(e.target.value)}
                    required
                    type="search"
                  />
                </div>
                <div className="col-md-4 col-5 d-flex justify-content-end">
                  <Button
                    disabled={isLoadingUp || isFetchingUp || !transactionNo}
                    className="px-4"
                    variant="success"
                    size="sm"
                    type="submit"
                    onClick={updateEchallanStatus}
                  >
                    {isLoadingV ? <BeatLoader color="#fff" /> : <>আপডেট করুন</>}
                  </Button>
                </div>
              </div>

              <Alert variant="info" className="mt-4">
                <label htmlFor="" className="mb-1">আপডেট সমূহ-</label>
                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    * আবেদন নাম্বার <br />
                    * আইপিএন নাম্বার <br />
                    * পেমেন্ট স্ট্যাটাস <br />
                  </div>
                  <div className="col-md-6">
                    * পেমেন্ট নাম্বার <br /> * ই-চালান নাম্বার <br /> * ই-চালান
                    স্ট্যাটাস
                  </div>
                </div>
              </Alert>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Observation;
